export default __webpack_public_path__ + "static/media/mesajlar-btn.aaa43a47.svg";